import script from "./KikakuKarisiyou.vue?vue&type=script&setup=true&lang=ts"
export * from "./KikakuKarisiyou.vue?vue&type=script&setup=true&lang=ts"

import "./KikakuKarisiyou.vue?vue&type=style&index=0&id=0d0c5709&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d0c5709"]])

export default __exports__